import { Home } from 'lucide-react'
import { Link } from 'react-router'
import { Button, LogoMark } from '@/components/ui'
import { useDocumentTitle } from '@/lib/hooks'
import { t } from '@/lib/i18n'

/** Global 404: a calm, bright card on the page background (REDESIGN.md section 9). */
export default function NotFoundPage() {
  useDocumentTitle([t('Page not found')])
  return (
    <div className="flex min-h-[calc(100dvh-64px)] flex-col">
      <section className="mx-auto mt-10 w-full max-w-[560px] px-4">
        <div className="flex flex-col items-center rounded-card border border-line bg-surface px-6 py-12 text-center shadow-card">
          <LogoMark height={48} />
          <p className="mt-6 text-tiny tracking-[0.12em] text-subtle">404</p>
          <h1 className="mt-2 text-page-title text-text">{t('We could not find that page')}</h1>
          <p className="mt-3 max-w-[420px] text-body text-muted">
            {t('The link may be broken, or the page may have moved. Let us get you back on track.')}
          </p>
        </div>
      </section>
      <div className="mx-auto flex w-full max-w-[1080px] flex-wrap items-center justify-center gap-3 px-4 py-10">
        <Button asChild variant="primary">
          <Link to="/">
            <Home size={18} strokeWidth={1.75} aria-hidden="true" />
            {t('Go home')}
          </Link>
        </Button>
      </div>
    </div>
  )
}
